/**
 * Déduplique les GET /mapping/sheet|calculate en vol (évite double requête pending).
 */
const inflight = new Map<string, Promise<unknown>>();

export function dedupeSheetFetch<T>(mapId: string, endpoint: string, run: () => Promise<T>): Promise<T> {
  const key = `${endpoint}:${mapId}`;
  const existing = inflight.get(key);
  if (existing) {
    return existing as Promise<T>;
  }
  const promise = run().finally(() => {
    inflight.delete(key);
  });
  inflight.set(key, promise);
  return promise;
}

export function cancelDedupeSheetFetch(mapId: string, endpoint?: string): void {
  if (endpoint) {
    inflight.delete(`${endpoint}:${mapId}`);
    return;
  }
  for (const key of inflight.keys()) {
    if (key.endsWith(`:${mapId}`)) {
      inflight.delete(key);
    }
  }
}
